export enum PressureCalculationMode {
  PRESSURE_GAIN = 'Pressure Gain',
  PRESSURE_DROP = 'Pressure Drop',
  OUTLET_PRESSURE = 'Outlet Pressure',
  DUTY = 'Duty',
  LOWEST = 'Lowest',
}
